import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { hideDialog } from '../../../store/dialog/dialog.actions';
import AlertPopup from '@aib/uikit-react/dist/Content/AlertPopup/AlertPopup';
import dialogConfigFactory from './dialogConfigFactory';
import langCommon from '~/shared/lang.common.json';

const lang = {
  DOCUMENT_LIBRARY_ERROR_HEAD:
    'Oops! We’re having a problem with the Document Library',
  DOCUMENT_LIBRARY_ERROR_CONTENT:
    'Don’t worry, all your documents are still safe with us. Please try again later.',
};

interface Props {
  hideDialog: (...args: unknown[]) => unknown;
}

function DocListErrorDialog({ hideDialog }: Props) {
  const [visible, setVisible] = useState(false);
  const dialogConfig = dialogConfigFactory({
    heading: lang.DOCUMENT_LIBRARY_ERROR_HEAD,
    content: lang.DOCUMENT_LIBRARY_ERROR_CONTENT,
    visible: true,
    accept: langCommon.OK,
    cancel: null,
  });

  useEffect(() => {
    let timeoutId;

    timeoutId = setTimeout(() => setVisible(true), 0);

    return () => {
      timeoutId = clearInterval(timeoutId);
    };
  });

  return (
    <AlertPopup
      id="DocListErrorDialog"
      title={dialogConfig.heading}
      confirmLabel={dialogConfig.accept}
      cancelLabel={dialogConfig.cancel}
      isOpen={visible}
      onCancel={hideDialog}
      onConfirm={hideDialog}
    >
      {dialogConfig.content}
    </AlertPopup>
  );
}

const mapStateToProps = (state, ownProps) => ({});

const mapDispatchToProps = {
  hideDialog,
};

export default connect(mapStateToProps, mapDispatchToProps)(DocListErrorDialog);
